import Course from "../../models/Course"
import QuizDisplay from "./components/QuizDisplay"
import VideoContentItem from "./components/ContentTypes/VideoContentItem.vue";



document.addEventListener('DOMContentLoaded', function () {
    Concrete.Vue.activateContext('cms', function (Vue, config) {

        const components = {
            VideoContentItem,
            QuizDisplay
        }

        const mergedComponents = {...config.components, ...components}

        const elements = document.querySelectorAll('[data-vue-course-app]')
        elements.forEach(element => {
            const courseID = element.getAttribute('data-course-id')
            const BASE_API_URL = '/api/v1/courses/'

            let app = new Vue({
                el: element,
                components: mergedComponents,
                data() {
                    return {
                        course: new Course(),
                    }
                },
                methods: {

                },
                mounted() {
                }
            })
        })
    })
})